import EditNameDialog from './EditNameDialog';

export default EditNameDialog;
